module.exports = __webpack_public_path__ + "static/stefan-10c3e8472fdc047b5b5a05ff54bd1404.jpg";